export default __webpack_public_path__ + "static/media/icon.5e9d5231.png";